import React, { useState, lazy } from 'react';
import { SectionWrapper } from './SectionWrapper';
import { motion, AnimatePresence } from 'framer-motion';
import { AlertCircle, BookOpen, FileText, MessageCircle, ShieldAlert, Instagram, ChevronDown } from 'lucide-react';
const bonos = [{
  num: 1,
  title: 'Checklist Riesgo Suicida Adolescentes',
  desc: 'Evaluación adaptada a menores + árbol de decisión + plan de seguridad + checklist plastificable + casos resueltos',
  icon: AlertCircle,
  img: 'https://images.unsplash.com/photo-1499209974431-9dddcece7f88?auto=format&fit=crop&w=900&h=300&q=80'
}, {
  num: 2,
  title: 'Guía Rápida Ley 26.061',
  desc: 'Los artículos clave + internación de menores + derechos del niño + plazos legales + glosario jurídico',
  icon: BookOpen,
  img: 'https://images.unsplash.com/photo-1505664194779-8beaceb93744?auto=format&fit=crop&w=900&h=300&q=80'
}, {
  num: 3,
  title: 'Plantilla Informe Juzgado de Familia',
  desc: 'Modelo completo + instrucciones de uso + errores frecuentes + casos resueltos',
  icon: FileText,
  img: 'https://images.unsplash.com/photo-1589994965851-a8f479c573a9?auto=format&fit=crop&w=900&h=300&q=80'
}, {
  num: 4,
  title: 'Scripts con Padres en Crisis',
  desc: 'Scripts para padres en conflicto + padre que se niega al tratamiento + comunicar diagnóstico por primera vez + alta con familia resistente',
  icon: MessageCircle,
  img: 'https://images.unsplash.com/photo-1511895426328-dc8714191300?auto=format&fit=crop&w=900&h=300&q=80'
}, {
  num: 5,
  title: 'Protocolo Detección y Denuncia de Abuso',
  desc: 'Indicadores por tipo de abuso + denuncia obligatoria paso a paso + coordinación con OVD + cómo documentar sin contaminar la prueba',
  icon: ShieldAlert,
  img: 'https://images.unsplash.com/photo-1518398046578-8cca57782e17?auto=format&fit=crop&w=900&h=300&q=80'
}, {
  num: 6,
  title: 'Pack Instagram Psiquiatría Infantojuvenil x20',
  desc: '20 posts con copy completo + hashtags + calendario mensual + estrategia de contenido para posicionarte como referente',
  icon: Instagram,
  img: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?auto=format&fit=crop&w=900&h=300&q=80'
}];
export function BonosGrid() {
  const [openBono, setOpenBono] = useState<number | null>(1);
  return <div className="bg-teal-50/40" data-id="element-35">
      <SectionWrapper data-id="element-36">
        <div className="text-center mb-8 md:mb-12" data-id="element-37">
          <p className="text-teal-700 font-bold tracking-wider text-[10px] md:text-xs uppercase mb-2 md:mb-3" data-id="element-38">
            INCLUIDOS GRATIS
          </p>
          <h2 className="text-[22px] md:text-3xl font-extrabold text-[#0a1f44] mb-2 md:mb-4 tracking-tight" data-id="element-39">
            6 Bonos Clínicos
          </h2>
          <p className="text-slate-600 max-w-2xl mx-auto text-[14px] md:text-base text-balance" data-id="element-40">
            Sin costo extra — incluidos en todas las ofertas
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-2.5 md:space-y-3" data-id="element-41">
          {bonos.map(bono => {
          const isOpen = openBono === bono.num;
          const Icon = bono.icon;
          return <motion.div key={bono.num} className={`border rounded-2xl overflow-hidden transition-all duration-300 ${isOpen ? 'bg-white border-teal-400 shadow-lg ring-1 ring-teal-900/5' : 'bg-white/70 border-teal-100 hover:bg-white shadow-sm cursor-pointer'}`} onClick={() => setOpenBono(isOpen ? null : bono.num)} data-id="element-42">
                {/* 3:1 Banner */}
                <div className="relative w-full aspect-[3/1] overflow-hidden bg-teal-100" data-id="element-43">
                  <img src={bono.img} alt={bono.title} loading="lazy" className="w-full h-full object-cover" data-id="element-44" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/45 to-black/10" data-id="element-45" />

                  <div className="absolute top-3 right-3 bg-teal-500 text-white text-[10px] md:text-xs font-black px-2.5 py-1 rounded-md uppercase tracking-wide shadow-md" data-id="element-46">
                    GRATIS
                  </div>

                  <div className="absolute inset-0 flex items-center justify-between px-3.5 md:px-6" data-id="element-47">
                    <div className="flex items-center gap-3 md:gap-4" data-id="element-48">
                      <div className={`w-9 h-9 md:w-12 md:h-12 rounded-xl flex items-center justify-center shrink-0 transition-colors backdrop-blur-sm ${isOpen ? 'bg-teal-500 text-white shadow-inner' : 'bg-white/85 text-teal-600'}`} data-id="element-49">
                        <Icon className="w-4 h-4 md:w-5 md:h-5" data-id="element-50" />
                      </div>
                      <div data-id="element-51">
                        <p className="text-[10px] md:text-xs font-bold text-teal-200 uppercase tracking-wider mb-0.5 md:mb-1 drop-shadow" data-id="element-52">
                          Bono {bono.num}
                        </p>
                        <h3 className="font-bold text-[13px] md:text-lg leading-tight text-white drop-shadow max-w-[180px] md:max-w-md" data-id="element-53">
                          {bono.title}
                        </h3>
                      </div>
                    </div>
                    <ChevronDown className={`w-5 h-5 text-white/90 transition-transform duration-300 shrink-0 ml-2 ${isOpen ? 'rotate-180 text-teal-300' : ''}`} data-id="element-54" />
                  </div>
                </div>

                <AnimatePresence data-id="element-55">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-56">
                      <div className="px-4 py-4 md:px-6 md:py-5" data-id="element-57">
                        <p className="text-slate-600 text-[13px] md:text-sm leading-relaxed" data-id="element-58">
                          {bono.desc}
                        </p>
                        <div className="mt-3 pt-3 border-t border-slate-100 flex items-center text-[12px] font-semibold text-slate-500" data-id="element-59">
                          <FileText className="w-3.5 h-3.5 mr-1.5 text-slate-400" data-id="element-60" />
                          30 págs
                        </div>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>

        <div className="mt-8 md:mt-12 max-w-md mx-auto bg-white border-2 border-teal-500 rounded-2xl p-5 md:p-6 text-center shadow-lg relative overflow-hidden" data-id="element-61">
          <div className="absolute top-0 inset-x-0 h-1 bg-gradient-to-r from-teal-400 to-teal-600" data-id="element-62"></div>
          <p className="text-slate-600 font-semibold text-[13px] md:text-sm mb-1.5 md:mb-2" data-id="element-63">
            Valor Total de los 6 Bonos
          </p>
          <div className="flex items-center justify-center gap-2 md:gap-3 text-lg md:text-2xl font-black" data-id="element-64">
            <span className="text-slate-400 line-through decoration-red-500/50 decoration-2" data-id="element-65">
              $84.000 ARS
            </span>
            <span className="text-teal-600" data-id="element-66">→ GRATIS ✅</span>
          </div>
          <p className="text-[12px] md:text-sm text-slate-500 mt-2 font-medium" data-id="element-67">
            Incluidos con cualquier oferta
          </p>
        </div>
      </SectionWrapper>
    </div>;
}